import React, { useEffect, useState } from "react"
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBCol, MDBDatatable, MDBIcon, MDBRow, MDBSpinner } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import { getBillingQuoteInfo, getUsageSummaryData } from "../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import TabIDConstant from "../../apiclients/TabIDConstant";
function UsageSummary() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();
    const [usageSummary, setusageSummary] = useState([]);
    const [isContractAccount, setisContractAccount] = useState(0);
    const [accountSeatSummary, setaccountSeatSummary] = useState({});
    const [contractSeatInfo, setcontractSeatInfo] = useState([]);
    const [accInfo, setAccInfo] = useState({});
    const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
    useEffect(() => {
        async function getUsageSummary() {
            setIsloading(true);
            const response = await getUsageSummaryData(JSON.parse(
                sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.OVERVIEW_LINK
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("response data is :::::::::: " + JSON.stringify(rawData));
            setusageSummary(rawData?.result ?? []);
            // setseatSummary(rawData?.seat_summary ?? []);
            setisContractAccount(rawData.is_contract_account !== undefined ? rawData.is_contract_account : 0);
            setaccountSeatSummary(rawData?.accountSeatsInfo ?? {});
            setcontractSeatInfo(rawData?.Contract_seats_report ?? []);
            const accountInfo = {
                provisioning_date: rawData?.provisioning_date ?? "",
                production_date: rawData?.production_date ?? "",
                contract_end_date: rawData?.contract_end_date ?? "",
                quote_id: rawData?.quote_id ?? "",
            }

            setAccInfo(accountInfo);
        }
        getUsageSummary();
    }, []);

    const handleQuoteClick = async (e, quote) => {
        e.preventDefault();
        try {
            let apiResponse = await getBillingQuoteInfo(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                quote
            );
            console.log("apiResponse ::::::::::::::: ", apiResponse);
            // debugger;

            let filename = "";
            if (apiResponse.status == 200) {
                const blob = await apiResponse.blob();

                // Create a URL and open it in a new tab
                const url = URL.createObjectURL(blob);
                window.open(url, "_blank");
            } else {
                // setInternalError(true);
            }
        } catch (error) {
            console.log("Error ::::::::: " + error);
        }
    };

    const usageData = {
        columns: [
            { label: 'Usage Type', field: 'usagetype', sort: false },
            { label: 'Usage', field: 'duration', sort: false },
            { label: 'Charges', field: 'charge', sort: false },
        ],
        rows: usageSummary,
    };

    const billingDataContract = {
        columns: [
            { label: "Seat Type", field: "seat_type" },
            // ...(isContractAccount === 1
            //     ? [
            ...(isWholesaleAcc === false
                ? [
            { label: "Contract Seats Quantity", field: "contrct_seat_count" },
            {
                label: "Non-Contract Seats Quantity",
                field: "noncontrct_seat_count",
                    }
                  ]
                : []),
            // ]
            // : []),
            { label: "Total Quantity", field: "total_seat_count" },
        ],
        rows: contractSeatInfo,
    };



    return (
        <React.Fragment>
            <>
                <MainLinks active={5} />
                <Body
                    tablinks={5}
                    sublink={284}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">

                                    <div class="card-header p-3 px-0 d-flex justify-content-between w-100">
                                        <h5 class="mb-0 ">
                                            {isContractAccount === 1 ? 'Contract Seat Report' : 'Seat Report'}

                                        </h5></div>

                                    {accountSeatSummary && (
                                        <>
                                            <MDBRow className="mb-4">
                                                {accountSeatSummary.acc_usr_seat_count && (
                                                    <MDBCol className="accountSeatCol">
                                                        <div className="p-3 border border-2  rounded-5 shadow-2-strong d-flex align-items-center justify-content-center flex-column accountSeatColdiv">
                                                            <h2 className="m-0">
                                                                {accountSeatSummary?.acc_usr_seat_count?.count ?? "0/0"}
                                                            </h2>
                                                            <p className="seatSummerySubText">
                                                                {accountSeatSummary?.acc_usr_seat_count?.label_text ?? ""}
                                                            </p>
                                                        </div>
                                                    </MDBCol>
                                                )}


                                                {accountSeatSummary?.seat_details_obj &&
                                                     Object.entries(accountSeatSummary.seat_details_obj)
                                                     .filter(([label, count]) => !(label === "Non-Billable Seats" && Number(count) === 0))
                                                     .map(([label, count]) => (
                                                        <>
                                                            <MDBCol className="accountSeatCol">
                                                                <div className="p-3 border border-2  rounded-5 shadow-2-strong d-flex align-items-center justify-content-center flex-column accountSeatColdiv ">
                                                                    <h2 className="m-0">{count}</h2>
                                                                    <p className="seatSummerySubText">{label}</p>
                                                                </div>
                                                            </MDBCol>
                                                        </>
                                                    ))}
                                            </MDBRow>
                                        </>
                                    )}
                                    <MDBDatatable
                                        responsive
                                        fixedHeader
                                        sortField="Seat Type"
                                        hover
                                        pagination={false}
                                        data={billingDataContract}
                                    />
                                    <div className="huntDataTable mt-4">
                                        <div class="card-header p-3 px-0 d-flex justify-content-between w-100">
                                            <h5 class="mb-0 ">
                                                Billing Account info
                                            </h5>
                                        </div>
                                        <div className="w-70">
                                            <div className="add-numbermain">
                                                <label>Provisioning Date</label>
                                                <strong>{accInfo?.provisioning_date ?? ""}</strong>
                                            </div>
                                            <div className="add-numbermain">
                                                <label>Production Date</label>
                                                <strong>{accInfo?.production_date ?? ""}</strong>
                                            </div>
                                            { !isWholesaleAcc &&
                                            <div className="add-numbermain">
                                                <label>Contract End Date</label>
                                                <strong>{accInfo?.contract_end_date ?? ""}</strong>
                                            </div>
                                            }
                                            <div className="add-numbermain">
                                                <label>Quote ID</label>
                                                <div>
                                                    {(accInfo?.quote_id ?? "")
                                                        .split(",")
                                                        ?.map((quote, index, arr) => (
                                                            <strong key={index}>
                                                                <a
                                                                    className="h6 text-decoration-underline"
                                                                    onClick={(e) => handleQuoteClick(e, quote)}
                                                                >
                                                                    {quote ?? ""}
                                                                </a>
                                                                {index !== arr.length - 1 && ", "}
                                                            </strong>
                                                        ))}
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="huntDataTable mt-4">
                                        <div class="card-header p-3 px-0 d-flex justify-content-between w-100">
                                            <h5 class="mb-0 ">
                                                Usage Summary
                                                <MDBIcon fas icon="info-circle" className="BillingGroupType ms-4 cursor-pointer" />
                                            </h5>
                                        </div>
                                        <div className="actionbar"></div>
                                        <MDBDatatable
                                            // search
                                            fixedHeader
                                            responsive
                                            pagination={false}
                                            maxHeight="calc(100vh - 400px)"
                                            minHeight="calc(100vh - 400px)"
                                            hover
                                            data={usageData}
                                        />

                                    </div>
                                </div>
                            </section>


                        </>
                    }
                />

                <Tooltip anchorSelect=".BillingGroupType" place="right" className="exampleTooltipLight">
                    Below is a summary of the current month's data.
                </Tooltip>

                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}


            </>
        </React.Fragment>
    )
}
export default UsageSummary


